import React, { act, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import SelectDropdown from "../components-react/SelectDropdown";
import { fetchAllTrainersByExpLvlData } from "../../redux/reducers/apiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { generate_dynamic_link } from "../../data/ApiEndpoints";
import "../../styles/branch-io/branch-io.css";

const DynamicPagesForm = ({ userInfoData, dynamicPageInfo, activeIndex }) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { allTrainerByExpLvlData } = useSelector((state) => state.api);

  const [allTrainers, setAllTrainers] = useState([]);
  const iniFormvalues = {
    selectedGym: "",
    selectedTrainer: "",
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [formErrors, setFormErrors] = useState({});
  const [generatedLink, setGeneratedLink] = useState(null);

  //   const onChangeInput = (e) => {
  //     const { id, checked, value } = e.target;

  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       [id]: e.target.type === "checkbox" ? checked : value,
  //     }));
  //   };

  const onChangeDropdown = (name, value) => {
    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
  };

  function validateForm(formValues) {
    let errors = {};

    if (dynamicPageInfo?.gym_id_required && !formValues.selectedGym) {
      errors.selectedGym = `required!`;
    }

    if (dynamicPageInfo?.trainer_id_required && !formValues.selectedTrainer) {
      errors.selectedTrainer = `required!`;
    }

    return errors;
  }

  const onSubmit = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        data: {
          screen_data: {
            screen: dynamicPageInfo?.screen_name ?? "",
            gymId: formValues.selectedGym?.value ?? "",
            trainerId: formValues.selectedTrainer?.value ?? "",
          },
        },
      };

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Verify Before Submitting!`,
        "No, Edit Form",
        "Yes, Submit Form"
      );
    }
  };

  const handleAdd = async (payload) => {
    const method = "POST";
    const endpoint = generate_dynamic_link;
    const token = userInfoData?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        if (result?.payload?.url) {
          setGeneratedLink(result.payload.url);
          setFormValues(iniFormvalues);
          setFormErrors({});

          toast.success(result?.payload?.message || "Success!");
        } else {
          toast.error("Link Is Not Generated, Try Again!");
        }
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(generatedLink);
    toast.success("Link copied to clipboard!");
  };

  const handleReGenerate = () => {
    setGeneratedLink("");
    setFormValues(iniFormvalues);
    setFormErrors({});
  };

  useEffect(() => {
    if (dynamicPageInfo?.gym_id_required) {
      dispatch(fetchGymData(userInfoData?.token));
    }
  }, [dynamicPageInfo?.gym_id_required]);

  useEffect(() => {
    if (dynamicPageInfo?.trainer_id_required) {
      dispatch(
        fetchAllTrainersByExpLvlData({
          queryParameters: formValues.selectedGym?.value
            ? `&gym_id=${formValues.selectedGym.value}&status=active`
            : "&status=active",
          token: userInfoData?.token,
        })
      );
    }
  }, [dynamicPageInfo?.trainer_id_required, formValues.selectedGym]);

  useEffect(() => {
    if (
      allTrainerByExpLvlData?.status &&
      allTrainerByExpLvlData?.data?.length > 0
    ) {
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainers(trainers);
    } else {
      setAllTrainers([]);
    }
  }, [allTrainerByExpLvlData]);

  useEffect(() => {
    handleReGenerate();
  }, [activeIndex]);

  return (
    <div className="dynamic-pages-form">
      {generatedLink ? (
        <div className="generated-link-container">
          <p className="generated-link-text">Generated Link:</p>
          <input
            type="text"
            className="generated-link-input"
            value={generatedLink}
            readOnly
          />
          <div className="button-group">
            <button
              className="btn-primary copy-btn"
              onClick={handleCopyToClipboard}>
              Copy to Clipboard
            </button>
            <button
              className="btn-secondary regenerate-btn"
              onClick={handleReGenerate}>
              Re-Generate Link
            </button>
          </div>
        </div>
      ) : (
        <form className="formContainer dynamic-linking-form-container">
          <div className="formInputsGrid threeGridSystem">
            {dynamicPageInfo?.gym_id_required && (
              <div className="formInputBox">
                <div
                  className={`commonWrapper ${
                    formErrors.selectedGym ? "formError" : ""
                  }`}>
                  <SelectDropdown
                    options={gymData}
                    selectedOption={formValues.selectedGym}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedGym", selectedValue)
                    }
                    name="Gym"
                  />
                </div>
              </div>
            )}

            {dynamicPageInfo?.trainer_id_required && (
              <div className="formInputBox">
                <div
                  className={`commonWrapper ${
                    formErrors.selectedTrainer && "formError"
                  }`}>
                  <SelectDropdown
                    options={allTrainers}
                    selectedOption={formValues.selectedTrainer}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedTrainer", selectedValue)
                    }
                    name="Trainer"
                  />
                </div>
              </div>
            )}

            <div
              className="formInputBox"
              style={{ justifyContent: "center", alignContent: "flex-start" }}>
              <Button
                variant="danger"
                className="btn-primary generate-link-btn"
                onClick={onSubmit}>
                Generate Link
              </Button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default DynamicPagesForm;
